export const isEmpty = (str?: string): boolean => {
  return !str || str.length === 0
}

export const isBlank = (str: string): boolean => {
  return !str || /^\s*$/.test(str)
}
